import React, { useEffect, useState } from 'react';
// import { useDashboardFilters } from './context/DashboardContext.js';
import { useSelector, useDispatch } from "react-redux"
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer.js"
import { getUsersStatsCardData } from "../../requests.js"
import "../../_css/UserManagement.css"


const stats = [
    {
        title: 'Total User',
        value: '1,320',
        subtitle: '(Last 30 Days)',
        color: '#3B82F6',
    },
    {
        title: 'Active Users',
        value: '892',
        subtitle: '+1k vs last month',
        color: '#10B981',
    },
    {
        title: 'Inactive Users',
        value: '100k',
        subtitle: '+100 vs last month',
        color: '#F97316',
    },
    {
        title: 'New Users ',
        value: '105',
        subtitle: '+20 vs last month',
        color: '#8B5CF6',
    }
]

const WaveSVG = ({ color = "#10B981", progress = 50 }) => {
    // progress (0 - 100) -> controls wave height
    const height = 30 - (progress / 100) * 20; // adjust scaling

    return (
        <svg
            width="90"
            height="48"
            viewBox="0 0 94 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d)">
                <path
                    d={`M5 27 C20 ${height}, 40 ${40 - height}, 60 ${height} S85 ${40 - height}, 90 ${height}`}
                    stroke={color}
                    strokeWidth="3.3"
                    fill="none"
                />
                <circle cx="85" cy={height} r="7.5" fill={color} />
            </g>
            <defs>
                <filter id="filter0_d" x="0" y="0" width="92" height="44" filterUnits="userSpaceOnUse">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix type="matrix"
                        values="0 0 0 0 0.06 0 0 0 0 0.72 0 0 0 0 0.5 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};


const StatsCard = ({ Data }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [userData, setUserData] = useState([

    ])
    // const { filters } = useDashboardFilters();
    const dispatch = useDispatch();


    useEffect(() => {
        const fetchStats = async () => {
            // dispatch(startLoader());
            try {
                const response = await getUsersStatsCardData();
                if (response.data.success) {
                    const { total, active, inactive, newUsers, prevNewUsers } = response.data.data;

                    // calculate differences
                    const diffNewUsers = newUsers - prevNewUsers;
                    const diffActive = active - (total - inactive);
                    const diffInactive = inactive - (total - active);

                    setUserData([
                        {
                            ...stats[0],
                            value: total.toLocaleString(),
                            subtitle: "(Last 30 Days)"
                        },
                        {
                            ...stats[1],
                            value: active.toLocaleString(),
                            subtitle: `${diffActive >= 0 ? "+" : ""}${diffActive.toLocaleString()} vs last month`
                        },
                        {
                            ...stats[2],
                            value: inactive.toLocaleString(),
                            subtitle: `${diffInactive >= 0 ? "+" : ""}${diffInactive.toLocaleString()} vs last month`
                        },
                        {
                            ...stats[3],
                            value: newUsers.toLocaleString(),
                            subtitle: `${diffNewUsers >= 0 ? "+" : ""}${diffNewUsers.toLocaleString()} vs last month`
                        },
                    ]);
                }
            } catch (error) {
                console.error("Fetching stats failed", error);
            } finally {
                // dispatch(stopLoader());
            }
        };
        fetchStats();
    }, [dispatch]);
    useEffect(() => {
        const fetchStats = async () => {
            // dispatch(startLoader());
            try {
                const response = await getUsersStatsCardData();
                if (response.data.success) {
                    const { total, active, inactive, newUsers, prevNewUsers } = response.data.data;

                    // calculate differences
                    const diffNewUsers = newUsers - prevNewUsers;
                    const diffActive = active - (total - inactive);
                    const diffInactive = inactive - (total - active);

                    setUserData([
                        {
                            ...stats[0],
                            value: total.toLocaleString(),
                            subtitle: "(Last 30 Days)"
                        },
                        {
                            ...stats[1],
                            value: active.toLocaleString(),
                            subtitle: `${diffActive >= 0 ? "+" : ""}${diffActive.toLocaleString()} vs last month`
                        },
                        {
                            ...stats[2],
                            value: inactive.toLocaleString(),
                            subtitle: `${diffInactive >= 0 ? "+" : ""}${diffInactive.toLocaleString()} vs last month`
                        },
                        {
                            ...stats[3],
                            value: newUsers.toLocaleString(),
                            subtitle: `${diffNewUsers >= 0 ? "+" : ""}${diffNewUsers.toLocaleString()} vs last month`
                        },
                    ]);
                }
            } catch (error) {
                console.error("Fetching stats failed", error);
            } finally {
                // dispatch(stopLoader());
            }
        };
        fetchStats();
    }, [Data]);
    return (
        <div className="row">
            {userData.map((stat, index) => {
                const isHovered = hoveredIndex === index;
                const activeColor = stat.color;

                return (
                    <div className="col-md-3" key={index}>
                        <div
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            className=""
                            style={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'space-between',
                                gap: "16px",
                                border: `1px solid ${isHovered ? activeColor : '#FFFFFF'}`,
                                borderRadius: '12px',
                                backgroundColor: '#FFFFFF',
                                padding: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: '4px'
                            }}>
                                <p style={{
                                    fontFamily: "Plus Jakarta Sans",
                                    margin: 0,
                                    fontSize: '16px',
                                    color: '#6B7280',
                                    fontWeight: 500,
                                    lineHeight: "24px",
                                    verticalAlign: "middle"
                                }}>
                                    {stat.title}
                                </p>
                                <h3 style={{
                                    verticalAlign: "middle",
                                    fontFamily: "Plus Jakarta Sans",
                                    fontSize: '24px',
                                    lineHeight: "32px",
                                    fontWeight: 700,
                                    color: isHovered ? activeColor : '#374151',
                                    margin: 0,
                                    transition: 'color 0.3s ease',
                                }}>
                                    {stat.value}
                                </h3>
                                <p style={{
                                    fontSize: '12px',
                                    color: '#6B7280',
                                    margin: 0,
                                    fontWeight: "400",
                                    fontFamily: "Plus Jakarta Sans",
                                    lineHeight: "18px",
                                    verticalAlign: "middle"
                                }}>
                                    {stat.subtitle}
                                </p>
                            </div>
                            <div>
                                <WaveSVG
                                    color={activeColor}
                                    progress={Math.min(100, (parseInt(stat.value.replace(/,/g, "")) / 1000) * 100)}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StatsCard;
